import { ArrowCollapseVerticalIcon } from './ArrowCollapseVerticalIcon';

/**
 * author: Google
 * id 1D7700E7-2963-479F-81E1-910E2566894F
 * name arrow-collapse-vertical
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-vertical.svg
 * tags
 * - Arrow 
 */
export const CompressIcon = ArrowCollapseVerticalIcon;
export default CompressIcon